module.exports = __webpack_public_path__ + "img/va.d257c97b.svg";